<cm-routed-dialog [dialogSize]="dialogSizes.Large" [dialogScroll]="false" [needsConfirmationToClose]="$templateGraphModified()">
    <ng-container cm-overlay-content>
        @if ($templateRevision(); as templateRevision) {
            @if ($templateGraph(); as templateGraph) {
                @if (templateRevision.template; as template) {
                    <cm-template-edit
                        [preTitle]="$preTitle()"
                        [title]="$title()"
                        [postTitle]="$revisionText()"
                        [allowTitleEdit]="$allowTitleEdit()"
                        (requestTitleChange)="handleTitleChanged($event)"
                        [templateGraph]="templateGraph"
                        [defaultCustomerId]="template.organization.legacyId"
                        [templateId]="template.id"
                        [templateType]="template.type"
                        [templateRevisionId]="templateRevision.id"
                        (templateGraphModified)="handleTemplateGraphModified($event)"
                        (requestSave)="handleSave($event)"
                        (requestSaveNewRevision)="handleSaveNewRevision($event)"
                        (requestClose)="handleClose()"
                    ></cm-template-edit>
                }
            } @else {
                <cm-loading-spinner>
                    <ng-container cm-text-bottom>
                        <div class="cm-loading-text">Loading Template Graph...</div>
                    </ng-container>
                </cm-loading-spinner>
            }
        } @else {
            <cm-loading-spinner>
                <ng-container cm-text-bottom>
                    <div class="cm-loading-text">Loading Template Revision...</div>
                </ng-container>
            </cm-loading-spinner>
        }
    </ng-container>
</cm-routed-dialog>
